import { Node, Permission } from 'entities/user';
import { State } from 'store';

export const Selectors = {
  getEmail: (state: State): string | null => state.data.auth.user && state.data.auth.user.email,
  getPhoneNumber: (state: State): string | null => state.data.auth.user && state.data.auth.user.phoneNumber,
  getPicture: (state: State): string | null => state.data.auth.user && state.data.auth.user.profileImageURL,
  getPreferredMfaMethod: (state: State): string | null =>
    state.data.auth.user && state.data.auth.user.preferredMfaMethod,
  getSub: (state: State): string | null => state.data.auth.user && state.data.auth.user.sub,
  getUsername: (state: State): string | null => state.data.auth.user && state.data.auth.user.name,

  hasPermission: (state: State, node: Node, permission: Permission): boolean => {
    if (!state.data.auth.permissions) {
      return false;
    }

    switch (node.level) {
      case 'SaleCycle':
        return state.data.auth.permissions.SaleCycle && state.data.auth.permissions.SaleCycle.indexOf(permission) > -1;

      case 'Group':
        return testPermission(state.data.auth.permissions.Groups, node.id, permission);

      case 'Brand':
        return testPermission(state.data.auth.permissions.Brands, node.id, permission);

      case 'Site':
        return testPermission(state.data.auth.permissions.Sites, node.id, permission);
    }
  },
};

const testPermission = (permissionMap: { [id: string]: Permission[] }, id: string, permission: Permission): boolean => {
  if (!permissionMap) {
    return false;
  }

  return (
    (!!permissionMap[id] && permissionMap[id].indexOf(permission) > -1) ||
    (!!permissionMap['*'] && permissionMap['*'].indexOf(permission) > -1)
  );
};
